<template>
  <div>
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="sellerName" label="销售方：">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"
                  placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="发票号：">
        <el-input v-model="dataForm.code" size="mini" clearable type="text"
                  placeholder="请输入发票号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">查询</el-button>


      </el-form-item>
    </el-form>
    <div class="tool-box">
      <el-button class="tool-item" @click="showPayMoneyDialogDialog" size="mini" type="warning" v-if="$hasPermission(`erp:receipt:create`)">添加发票</el-button>
      <el-button class="tool-item" @click="showPayMoneyDialogDialog" size="mini" type="warning"  v-if="$hasPermission(`erp:pay:batch`)">批量付款</el-button>
    </div>
    <SweetTable ref="table" url="/erp/receipt/page" :selection="true" :query-form="dataForm" api-version="v2"
                :auto-load="false"
                :before-table-binding="beforeTableBinding">
      <el-table-column prop="sellerName" label="销售方" header-align="center"
                       align="center" min-width="160" :formatter="companyNameFormatter"></el-table-column>
      <el-table-column prop="operateDate" label="开票时间" header-align="center"
                       align="center" width="160"></el-table-column>
      <el-table-column prop="code" label="发票号" header-align="center"
                       align="center" min-width="160"></el-table-column>
      <el-table-column prop="totalAmount" label="发票金额" header-align="center"
                       align="center" width="100"></el-table-column>
      <el-table-column prop="createDate" label="制单时间" header-align="center"
                       align="center" width="160"></el-table-column>
      <el-table-column prop="creatorName" label="制单人" header-align="center"
                       align="center" width="100"></el-table-column>
      <el-table-column  label="审核状态" header-align="center"
                       align="center" width="100">
        <template #default="{row}">
          <el-tag v-if="row.auditStatus === 10" type="danger">未审核</el-tag>
          <el-tag v-else-if="row.auditStatus === 20" type="success">已审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="auditTime" label="审核时间" header-align="center"
                       align="center" width="160"></el-table-column>
      <el-table-column prop="auditManName" label="审核人" header-align="center"
                       align="center" width="100"></el-table-column>
      <el-table-column prop="payedAmount" label="已付款" header-align="center"
                       align="center" width="100">
      </el-table-column>
      <el-table-column prop="unPayAmount" label="未付款" header-align="center"
                       align="center" width="100"></el-table-column>
      <el-table-column label="操作" header-align="center" fixed="right"
                       align="center" width="160">
        <template #default="{row}">
          <el-button type="text" @click="showDetail(row)">查看详情</el-button>
          <!--          <el-button type="text" @click="doEdit(row)">修改</el-button>-->
          <el-button type="text" @click="doDel(row)" v-if="$hasPermission('erp:pay:delete')">删除</el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <PayMoneyDialog ref="PayMoneyDialog" @complete="reload()"></PayMoneyDialog>
    <DetailDialog ref="DetailDialog"></DetailDialog>
    <EditDialog ref="EditDialog" @complete="reload()"></EditDialog>
  </div>
</template>

<script>
import EditDialog from '@/views/modules/erp/pay/EditDialog.vue'
import BigNumber from 'bignumber.js'
import PayMoneyDialog from '@/views/modules/erp/pay/pay-money-dialog.vue'
import DetailDialog from '@/views/modules/erp/pay/detail-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import { hasPermission } from '@/utils'

export default {
  mixins: [SweetTable],
  components: { PayMoneyDialog, DetailDialog, EditDialog },
  props: {
    receiptType: {
      type: String,
      default: 'make',//make:加工费发票，purchase:采购发票
      required: true
    }
  },
  data () {
    return {
      dataForm: {
        sellerName: '',
        code: '',
        receiptType: ''
      },
    }
  },
  watch: {
    receiptType: {
      handler:function (val){
        this.dataForm.receiptType = val
        this.reload()
      },
      immediate:true
    }
  },
  methods: {
    hasPermission,
    doDel (row) {
      this.$confirm(`是否要删除发票【${row.code}】？`, '操作提示').then(() => {
        this.$api2.delete(`/erp/receipt`, { data: [row.id] }).then(res => {
          this.getDataList()
          this.$message.success('删除成功')
        })
      })
    },
    doEdit (row) {
      this.$refs.EditDialog.init(row.id)
    },
    showDetail (row) {
      this.$refs.DetailDialog.init(row.id)
    },
    companyNameFormatter (row, column, cellValue, index) {
      if (!cellValue) {
        return ''
      }
      return cellValue.replace('有限公司', '')
    },
    showPayLogDialog (row) {
      this.$refs.payLogDialog.queryForm.receiptCode = row.receiptCode
      this.$refs.payLogDialog.init()
    },
    showPayMoneyDialogDialog () {
      let dataList = this.$refs.table.dataListSelections
      if (dataList.length === 0) {
        return this.$message.error('请选择发票')
      }
      let sellerId = dataList[0].sellerId
      if (dataList.find(m => m.sellerId !== sellerId)) {
        return this.$message.error('付款对象不一致,请重新选择')
      }
      let payList = dataList.map(item => {
        return {
          sellerName: item.sellerName,
          sellerId: item.sellerId,
          receiptCode: item.code,
          payId: item.id,
          payedAmount: item.payedAmount,
          unPayAmount: item.unPayAmount,
          amount: item.unPayAmount,
          totalAmount: item.totalAmount
        }
      })
      this.$refs.PayMoneyDialog.init(payList)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        let totalAmount = new BigNumber(item.totalAmount)
        item.unPayAmount = totalAmount.minus(item.payedAmount || 0).toFixed(3)
      })
    },

  }
}
</script>

<style scoped>

</style>
